import {
    faList,
    faThLarge,
    faSearch,
    faTimes
} from "@fortawesome/free-solid-svg-icons";

export const GRID = "grid";
export const LIST = "list";
export const BTN_ACTIVE = 'switchbox-listbtn-active';
export const MOVE = 'move';
export const PARENTS = 'parents_';
//export const CONN = "connect_";
export const CONN = "connector_";
export const CHECKBOX_LEN = 126.36953735351562;
export const ASC = 'asc';
export const DESC = 'desc';
//export const SHIFT = 16;  // keyCode Shift
export const SHIFT = 'Shift';
//export const SHIFT = 'Control';
//export const SHIFT = 17; // keyCode Control
export const INPUT = 'input';
export const DROPDOWN = 'dropdown';
export const MULTISELECT = 'multiselect';
export const MASK = 'mask';
export const CONNECTOR = 'connector';
export const LOCAL_HOST = "http://localhost:3000";
export const DUMMY_X = 'XXXXXX';
export const DATE_FROMTO = 'datefromto';
//export const CONNECT = 'connect';
export const CONNECT = 'connector';
export const EXPERT_PRE = 'expertsearchpresets';
export const ADVANCED_PRE = 'advancedsearchpresets';
export const CONTAINS = "contains";
export const SEARCH_TYPE = "searchtype";
export const OR = 'or';
export const GROUP = 'group';
export const PSEARCH = 'profi_search';
export const DATE = 'date';
export const NUMBER = 'number';
export const DYN_TREE = 'tagtree_dynamic';
export const TEXT = 'text';
export const USERLIST = 'userlist';
export const FLEXLIST = 'flexlist';
export const PREVIEW = 'preview';


export const DD_SELECT = {
    name: DUMMY_X,
    value: DUMMY_X,
    intl: "advanced.select"
}
export const SOURCE_OBJ = [
    { id: "testid01", type: "text", targetType: "input", intl: "Titel", field: "title" },
    { id: "testid02", type: "text", targetType: "input", intl: "Objekt", field: "object" }
];

export const FLEXDATE = 'flexdate';

export const SEARCH_TYPE_ITEMS = [
    { name: "contains", intl: "advanced.searchtype.contains", value: CONTAINS },
    { name: "is_equal", intl: "advanced.searchtype.equal", value: "=" },
    { name: "not_equal", intl: "advanced.searchtype.not_equal", value: "!=" },
    // { name: "greater_than", intl: "advanced.searchtype.greater_than", value: ">" },
    // { name: "less_than", intl: "advanced.searchtype.less_than", value: "<" },
    // { name: "from_until", intl: "advanced.searchtype.from_until", value: "from_until" },
    { name: "empty", intl: "advanced.searchtype.empty", value: "empty" },
    { name: "not_empty", intl: "advanced.searchtype.not_empty", value: "not_empty" },
];

export const SEARCH_TYPE_ADD = [
    { name: "greater_than", intl: "advanced.searchtype.greater_than", value: ">" },
    { name: "less_than", intl: "advanced.searchtype.less_than", value: "<" },
]

export const SEARCH_TYPE_FLEXDATE = [
    { name: "less_than", intl: "advanced.searchtype.less_than", value: "less_than" },
    { name: "less_equal_than", intl: "advanced.searchtype.less_equal_than", value: "less_equal_than" },
    { name: "equal", intl: "advanced.searchtype.gleich", value: "equal" },
    { name: "greater_equal_than", intl: "advanced.searchtype.greater_equal_than", value: "greater_equal_than" },
    { name: "greater_than", intl: "advanced.searchtype.greater_than", value: "greater_than" },
]


export const SORT_OBJ = {
    name: "sorting",
    intl: "advanced.sorting",
    data: [
        { name: "created", intl: "advanced.created", value: "created" },
        { name: "title", intl: "title", value: "titlie" }],
    sortOrder: 'sortOrder'
}

export const CONNECTOR_OBJ = {
    // name: "connect",
    // type: "connect",
    // targetType: "connector",
    name: CONNECTOR,
    type: CONNECTOR,
    targetType: CONNECTOR,
    field: CONNECTOR,
    isDD: true,
    data: [
        { name: "and", intl: "advanced.and", value: "and" },
        { name: "or", intl: "advanced.or", value: "or" }],
}

export const BEGIN_OR = { "field": "", "type": "BEGIN_OR", "value": "" };
export const END_OR = { "field": "", "type": "END_OR", "value": "" };
export const BEGIN_GROUP = { "field": "", "type": "BEGIN_GROUP", "value": "" };
export const END_GROUP = { "field": "", "type": "END_GROUP", "value": "" };
export const FULLTXT = 'fulltext';
export const BYFIELDS = 'byfields';
export const IS_FULLTOFIELDS = 'isFullToFields';
export const INPUT_NUM = 'input_number';

export const SAVE_OBJ = {
    name: "savedObj",
    intl: "savedObj",
    data: [
        { name: "my_first_data", intl: "my_first_data", value: "my_first_data" },
        {
            name: "my_second_data", intl: "my_second_data", value: "my_second_data"
        }]
}

export const SAVEDLG_ITEMS = [
    { name: "savedSearch", intl: "advanced.save.name", required: true, type: "text" },
];

export const HELPDLG_ITEMS = [
    { name: "helpSearch", intl: "advanced.help.search", type: "text" },
];

export const VIEW_ICON_BTNS = [
    { name: LIST, icon: faList, htmlClass: "ms-4" },
    { name: GRID, icon: faThLarge },
];

export const SEARCH_BTN_GROUP = [
    { name: "discard_changes", icon: faTimes, intl: "advanced.discard_change", onClick: "onDiscardChanges", outline: true },
    { name: "search", icon: faSearch, intl: "advanced.search", onClick: "onSearch" }
];

export const SEARCH_INIT = { targetFields: [], userInputs: {}, advancedObject: {}, searchedListCur: null };

export const HELP_INFO = "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.";

//VIDEO PLAYER 
export const SPEED_ITEMS = [
    { name: '2x', value: '2', intl: '2x' },
    { name: '1.5x', value: '1.5', intl: '1.5x' },
    { name: 'Normal', value: '1', intl: 'Normal', htmlClass: 'tvactive-option' },
    { name: '0.75x', value: '0.75', intl: '0.75x' },
    { name: '0.5x', value: '0.5', intl: '0.5x' },
];

export const PLAYER_INTERVAL_TIME = 10;

